module.exports = "/reports/directives/salesTableColumn-c422d4.html";